export default "__VITE_ASSET__DQ1NJ6rx__"